import {createAction} from "@reduxjs/toolkit";

export const updateBlockNumber = createAction("@blockchain/blockNumber");
export const updateETHPrice = createAction("@blockchain/ethPrice");
